if($('.news-listings').length) {

    if($('.header-dropdown').length) {
        $('.header-dropdown button').on('click', function() {
            $(this).parent().toggleClass('active');
            $(this).parent().find('.header-dropdown-menu').slideToggle();
        });
    }

}


if($('.blog-post-detail').length) {

    $('.copy-link-button').on('click', function() {

        let url = $(this).data('url');

        navigator.clipboard.writeText(url).then(function() {
            console.log('Async: Copying to clipboard was successful!');
            alert('Link copied to clipboard!');
        }, function(err) {
            console.error('Async: Could not copy text: ', err);
        });

    });

}

if($('.blog-archive-page').length) {

    let loadMoreButton = $('#load-more-posts'),
        page = 1,
        maxPages = window.max_blog_pages,
        category = window.blog_category,
        loading = false,
        finished = false,
        postContainer = $('.news-listings-more-container');

    console.log(maxPages);
    console.log(page);

    loadMoreButton.on('click', function() {
        page += 1;
        loadPosts();
    });

    function loadPosts() {

        if(loading || finished) return;

        loading = true;

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'post',
            data: {
                action: 'load_more_posts',
                page: page,
                category: category
            },
            success: function(response) {

                if(response.length) {
                    postContainer.append(response);
                } else {
                    finished = true;
                    loadMoreButton.remove();
                }

                loading = false;

                checkLoadMoreButton();

            }
        });

    }

    function checkLoadMoreButton() {
        if(page >= maxPages) {
            $('.load-more-button-container').remove();
        }
    }

}
